// extracted by mini-css-extract-plugin
module.exports = {"component":"sidebar-footer-component--2eYq9"};